module.exports = __webpack_public_path__ + "img/travel-content.8f6445b4.webp";